import { Component, OnInit, ElementRef, OnDestroy } from "@angular/core";
import { notificationService } from "./package-notification.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";

@Component({
  selector: "app-package-notification",
  templateUrl: "./package-notification.component.html",
  styleUrls: ["./package-notification.component.sass"],
})
export class PackageNotificationComponent implements OnInit {
  sound: any;
  itemsPerPage: number = 10;
  allPackagesList: any[] = [];
  totalItems: number = 0;
  recentPackagesList: any[] = [];
  isVisible = false;
  refreshIntervalId: any;
  currentItem: number = 0;
  previousTotalItems: number = 0;
  pMRefreshInterval: any;
  constructor(
    private notificationService: notificationService,
    private spinner: NgxSpinnerService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.sound = new Audio(
      "../../../../../../assets/images/notificationSound1.mp3",
    );
    this.packageNotification();
    this.getNotifications();
    this.ENTPpackageNotification();
    this.refreshIntervalId = setInterval(() => {
      // this.packageNotification();
      // this.ENTPpackageNotification();
      this.getNotifications();
    }, 30000);
    // this.refreshIntervalId = setInterval(() => {
    //   this.getNewDrivers();
    // }, 3000);
    this.pMNotification();
    // this.driverWithdrawalReq();
    // this.pMRefreshInterval = setInterval(
    //   () => {
    //     this.pMNotification();
    //     this.driverWithdrawalReq();
    //     // this.driverWithdrawalReq();
    //   },
    //   20 * 60 * 1000,
    // );
  }

  packageNotification() {
    let data = {
      perPage: this.itemsPerPage,
      page: 0,
      status: 0,
    };
    this.notificationService
      .packageNotification(data)
      .subscribe((result: any) => {
        // console.log("status ",result)
        this.allPackagesList = result.data;
        this.totalItems = result.totalRecords;
        this.recentPackagesList = this.filterRecentItems(this.allPackagesList);
        // console.log("recentPackageList", this.recentPackagesList)
        this.spinner.hide();

        // Compare previous and current totalItems
        if (this.previousTotalItems !== null) {
          if (this.totalItems > this.previousTotalItems) {
            // console.log("New trip available. Previous:", this.previousTotalItems, "Current:", this.totalItems);
            this.sound.play();
          } else {
            // console.log("No new trip. Previous:", this.previousTotalItems, "Current:", this.totalItems);
          }
        }
        // Update the previous totalItems
        this.previousTotalItems = this.totalItems;
      });
  }

  gty(page: any) {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: page - 1,
      status: 0,
    };
    this.notificationService
      .packageNotification(data)
      .subscribe((result: any) => {
        this.allPackagesList = result.data;
        this.totalItems = result.totalRecords;
        this.recentPackagesList = this.filterRecentItems(this.allPackagesList);
        this.spinner.hide();
      });
  }
  filterRecentItems(items: any[]): any[] {
    const currentTime = Date.now();
    const TwentyMinutes = 20 * 60 * 1000;

    return items.filter((item) => {
      const itemCreationTime = item.timestamp * 1000; // Convert UNIX timestamp to milliseconds
      return currentTime - itemCreationTime <= TwentyMinutes;
    });
  }

  filterENTPRecentItems(items: any[]): any[] {
    const currentTime = Date.now();
    const twentyMinutes = 20 * 60 * 1000;

    return items.filter((item) => {
      const itemCreationTime = new Date(item.createdAt).getTime();
      return currentTime - itemCreationTime <= twentyMinutes;
    });
  }

  ngOnDestroy(): void {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }
  routeViewDetails(data: any) {
    this.router.navigate(["dashboard/viewPackageDetails"], {
      queryParams: { id: data._id },
    });
  }
  hideNotification() {
    this.isVisible = false;
  }

  //  Enterprise Notification

  allENTPPackagesList: any;
  ENTPTotalItems: any;
  recentENTPPackagesList: any;
  previousENTPTotalItems: any;
  ENTPpackageNotification() {
    let data = {
      perPage: this.itemsPerPage,
      page: 0,
      status: 1,
    };
    this.notificationService.getTrips(data).subscribe((result: any) => {
      // console.log("status ",result)
      this.allENTPPackagesList = result.data;
      this.ENTPTotalItems = result.totalRecords;
      this.recentENTPPackagesList = this.filterENTPRecentItems(
        this.allENTPPackagesList,
      );
      // console.log("recentPackageList", this.recentPackagesList)
      this.spinner.hide();

      // Compare previous and current totalItems
      if (this.previousENTPTotalItems !== null) {
        if (this.ENTPTotalItems > this.previousENTPTotalItems) {
          // console.log("New trip available. Previous:", this.previousTotalItems, "Current:", this.totalItems);
          this.sound.play();
        } else {
          // console.log("No new trip. Previous:", this.previousTotalItems, "Current:", this.totalItems);
        }
      }
      // Update the previous totalItems
      this.previousENTPTotalItems = this.ENTPTotalItems;
    });
  }

  // Packers mover Notification
  allPackerMoverList: any;
  allPackerMoverList_forFilter: any;
  recentPMList: any;
  pMTotalItems: any;
  previousPMTotalItems: any;
  pMNotification() {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: 0,
      isDeleted: 0,
    };
    this.notificationService
      .packerMoverNotification(data)
      .subscribe((result: any) => {
        // console.log('all packermover data',result);
        this.spinner.hide();
        if (result.statusCode == 200) {
          this.allPackerMoverList = result.data;
          this.pMTotalItems = result.totalRecords;
          this.recentPMList = this.filterPackerMoverTrips(
            this.allPackerMoverList,
          );
          // console.log( "packemoverNotification", this.recentPMList)

          // Compare previous and current totalItems
          if (this.previousPMTotalItems !== null) {
            if (this.pMTotalItems > this.previousPMTotalItems) {
              // console.log("New trip available. Previous:", this.previousTotalItems, "Current:", this.totalItems);
              this.sound.play();
            } else {
              // console.log("No new trip. Previous:", this.previousTotalItems, "Current:", this.totalItems);
            }
          }
          // Update the previous totalItems
          this.previousPMTotalItems = this.pMTotalItems;
        } else {
          this.allPackerMoverList = [];
        }
      });
  }

  filterPackerMoverTrips(items: any[]): any[] {
    const currentTime = Date.now();
    const oneDay = 12 * 60 * 60 * 1000; // 1/2 day in milliseconds
    return items.filter((item) => {
      const itemCreationTime = item.timestamp * 1000; // Convert UNIX timestamp to milliseconds
      return currentTime - itemCreationTime <= oneDay;
    });
  }

  routeViewPMDetails(data: any) {
    this.router.navigate(["dashboard/viewPackerMoverRequest"], {
      queryParams: { id: data._id },
    });
  }

  allWithdrawalReq: any;
  withdrawalReqTotalItems: number = 0;
  previousWithdrawalTotalItems: number = 0;
  recentWithdrawalList: any;
  driverWithdrawalReq() {
    this.spinner.show();
    let data = {
      perPage: 5,
      page: 0,
      isDeleted: 0,
    };
    this.notificationService
      .getDriverWithdrawalReq(data)
      .subscribe((result: any) => {
        // console.log('all withdrawal data',result);
        this.spinner.hide();
        if (result.statusCode == 200) {
          this.allWithdrawalReq = result.data.filter(
            (item: any) => item.status === "PENDING",
          );
          this.withdrawalReqTotalItems = result.totalRecords;

          this.recentWithdrawalList = this.filterRecentItems(
            this.allWithdrawalReq,
          );
          // console.log( "driverWithdrawalReq", this.recentWithdrawalList)

          // Compare previous and current totalItems
          if (this.previousWithdrawalTotalItems !== null) {
            if (
              this.withdrawalReqTotalItems > this.previousWithdrawalTotalItems
            ) {
              // console.log("New withdraw Req available. Previous:", this.previousWithdrawalTotalItems, "Current:", this.withdrawalReqTotalItems);
              this.sound.play();
            } else {
              // console.log("No new withdraw Req. Previous:", this.previousWithdrawalTotalItems, "Current:", this.withdrawalReqTotalItems);
            }
          }
          // Update the previous totalItems
          this.previousWithdrawalTotalItems = this.withdrawalReqTotalItems;
        } else {
          this.allPackerMoverList = [];
        }
      });
  }

  notifications: any[] = [];
  unreadCount = 0;
  previousNotificationsLength: number = 0;
  getNotifications() {
    this.notificationService.getNotifications().subscribe({
      next: (res: any) => {
        this.notifications = res.data || [];
        this.unreadCount = this.notifications.length;
        // Compare previous and current totalItems
        if (this.previousNotificationsLength !== null) {
          if (this.notifications.length > this.previousNotificationsLength) {
            this.sound.play();
          } else {
          }
        }
        // Update the previous totalItems
        this.previousNotificationsLength = this.notifications.length;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  // openNotification(notification: any) {
  //   this.getNotifications();
  //   this.notificationService.markNotificationRead(notification._id).subscribe({
  //     next: () => {
  //       this.notifications = this.notifications.filter(
  //         (x) => x._id !== notification._id,
  //       );

  //       this.unreadCount = this.notifications.length;

  //       switch (notification.type) {
  //         case "packersMovers":
  //           this.router.navigate([
  //             "/packer-mover-request-details",
  //             notification.requestId,
  //           ]);

  //           break;

  //         case "trip":
  //           this.router.navigate(["/trip-details", notification.tripId]);

  //           break;

  //         default:
  //           this.router.navigate(["/dashboard"]);
  //       }
  //     },
  //     error: (err: any) => {
  //       console.log(err);
  //     },
  //   });
  // }

  openNotification(notification: any) {
    this.notificationService.markNotificationRead(notification._id).subscribe({
      next: () => {
        this.notifications = this.notifications.filter(
          (x) => x._id !== notification._id,
        );

        this.unreadCount = this.notifications.length;

        switch (notification.type) {
          case "newUserRegistration":
            this.router.navigate(["/dashboard/viewUserDetails"], {
              queryParams: {
                id: notification.notificationId,
              },
            });

            break;

          case "newDriverRegistration":
            this.router.navigate(["/dashboard/driverPartnerRequest"], {
              queryParams: {
                id: notification.notificationId,
              },
            });

            break;

          case "package":
            this.router.navigate(["/dashboard/viewPackageDetails"], {
              queryParams: {
                id: notification.notificationId,
              },
            });

            break;

          case "enterpriseTrip":
            this.router.navigate(["/dashboard/enterprise-view-trip"], {
              queryParams: {
                id: notification.notificationId,
              },
            });

            break;

          case "packersMoversRequest":
            this.router.navigate(["/dashboard/view-website-packers-movers"], {
              queryParams: {
                id: notification.notificationId,
              },
            });

            break;

          case "packersMoversUser":
            this.router.navigate(
              ["/dashboard/view-website-packers-movers-user"],
              {
                queryParams: {
                  id: notification.notificationId,
                },
              },
            );

            break;
          case "packersMoversApp":
            this.router.navigate(["/dashboard/packerMoverRequest"]);

            break;
          case "warehouseRequirement":
            this.router.navigate(["/dashboard/view-warehouse-requirements"], {
              queryParams: {
                id: notification.notificationId,
              },
            });

            break;
          case "USER_VACANT_VEHICLE_SEARCH":
            this.router.navigate(
              ["/dashboard/user-view-vacant-vehicle-search"],
              {
                queryParams: {
                  id: notification.notificationId,
                },
              },
            );

            break;
          case "DRIVER_LOAD_SEARCH":
            this.router.navigate(["/dashboard/driver-view-load-search"], {
              queryParams: {
                id: notification.notificationId,
              },
            });

            break;

          default:
            this.router.navigate(["/dashboard"]);
        }
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }
}
